import { InvalidFormatError, IOHelper, JSONHelper, toJSONAttributeUsage, UInt256AttributeModel, } from '@neo-one/client-common';
import { AttributeBase } from './AttributeBase';
import { AttributeUsage } from './AttributeUsage';
export class UInt256Attribute extends AttributeBase(UInt256AttributeModel) {
    constructor({ usage, value }) {
        super({ usage, value });
        this.size = IOHelper.sizeOfUInt8 + IOHelper.sizeOfUInt256;
    }
    static deserializeWireBase(options) {
        const { reader } = options;
        const { usage } = super.deserializeAttributeWireBase(options);
        if (!(usage === AttributeUsage.ContractHash ||
            usage === AttributeUsage.Vote ||
            usage === AttributeUsage.Hash1 ||
            usage === AttributeUsage.Hash2 ||
            usage === AttributeUsage.Hash3 ||
            usage === AttributeUsage.Hash4 ||
            usage === AttributeUsage.Hash5 ||
            usage === AttributeUsage.Hash6 ||
            usage === AttributeUsage.Hash7 ||
            usage === AttributeUsage.Hash8 ||
            usage === AttributeUsage.Hash9 ||
            usage === AttributeUsage.Hash10 ||
            usage === AttributeUsage.Hash11 ||
            usage === AttributeUsage.Hash12 ||
            usage === AttributeUsage.Hash13 ||
            usage === AttributeUsage.Hash14 ||
            usage === AttributeUsage.Hash15)) {
            throw new InvalidFormatError(`Invalid AttributeUsageModel. Received: ${usage}`);
        }
        const value = reader.readUInt256();
        return new this({ usage, value });
    }
    serializeJSON(_context) {
        return {
            usage: toJSONAttributeUsage(this.usage),
            data: JSONHelper.writeUInt256(this.value),
        };
    }
}

//# sourceMappingURL=UInt256Attribute.js.map
